import React from 'react'
import { Row, Cell, H6, Subheading, Button, InlineButton, useOverlay, DescriptionTooltip, Separator } from '@fs/zion-ui'
import transl from './ImageOrganizeFooter.transl'
import { workflowStatuses } from '../../helpers'
import { ResetDialog } from './Dialogs/Dialogs'

export function ItemInProgressByAnotherUser({ disabled, onNextItemClick }) {
  return (
    <Row alignY="middle" guttersY="none">
      <Cell growX>
        <H6>
          {transl.editingUnavailable()}
          <Subheading>{transl.anotherUserSubtitle()}</Subheading>
        </H6>
      </Cell>
      <Button disabled={disabled} onClick={onNextItemClick}>
        {transl.nextItemText()}
      </Button>
    </Row>
  )
}

export function StatusAlreadySetView({ disabled, onNextItemClick, currentGroupStatus, onResetClick }) {
  const overlay = useOverlay()

  // eslint-disable-next-line react/no-unstable-nested-components
  const ResetStatusButton = () => (
    <InlineButton disabled={disabled} onClick={overlay.handleClick}>
      {transl.resetStatusText()}
    </InlineButton>
  )
  const subtitle = (
    <>
      <ResetStatusButton /> {transl.toMakeChanges()}
    </>
  )
  const title = currentGroupStatus === workflowStatuses.COMPLETED ? transl.completedTitle() : transl.itemSkipped()

  return (
    <>
      <Row alignY="middle" guttersY="none">
        <Cell growX>
          <H6>
            {title}
            <Subheading>{subtitle}</Subheading>
          </H6>
        </Cell>
      </Row>
      <Separator size="xxs" />
      <Row alignX="end" guttersY="none">
        <Button disabled={disabled} onClick={onNextItemClick} noShrinkX emphasis="medium">
          {transl.nextItemText()}
        </Button>
        <ResetDialog overlay={overlay} onResetClick={onResetClick} />
      </Row>
    </>
  )
}

export function ButtonWithToolTip({
  onClick,
  emphasis = 'high',
  disabled,
  buttonText,
  label = transl.taskNotAvailable(),
  description = transl.skipAndIsCorrectBody(),
}) {
  return (
    <DescriptionTooltip
      target={
        <Button emphasis={emphasis} disabled={disabled} onClick={onClick}>
          {buttonText}
        </Button>
      }
      label={label}
      description={description}
    />
  )
}
